import { TableWrapper, TableHead, TableBody, TableRow, PaginationContainer } from "./components";
import style from "./TablePromoCode.module.scss";

export function TablePromoCode() {
    return (
        <div className={style.tableManager}>
            <div className={style.tableContainer}>
                <div data-scrollable className={style.scrollBox}>
                    <TableWrapper>
                        <TableHead />
                        <TableBody>
                            {(data) => (
                                <TableRow key={data.id} data={data} />
                            )}
                        </TableBody>
                    </TableWrapper>
                </div>
            </div>
            <PaginationContainer />
        </div>
    )
}